require('../utils/lp_boclips_video_handler');
require('../actions/lp_boclips_actions');
require('notification_helper');

const { $, LP } = window;
const NotificationHelper = LP.module('NotificationHelper');
const LpBoclips = LP.module('LpBoclips');

let BoclipsModal = function () {
  function BoclipsModal(url, videoUrl, params, transition) {
    this.url = url;
    this.videoUrl = videoUrl;
    this.transition = transition;
    this.params = params;
    this.$container = BoclipsModal.selector();
    this.video_handler = new LpBoclips.LpBoclipsVideoHandler({
      videoUrl: this.videoUrl,
      data: { ...(params || {}), from_modal: true }
    });
    this.default_url = `/boclips/teachers/${this.video_handler.videoId}`;
    if (!this.url || $.trim(String(this.url)) == '') {
      this.url = this.default_url;
    }
    if (!this.params) {
      this.params = {};
    }
    if (BoclipsModal.context && typeof this.setContext === 'function') {
      this.setContext(BoclipsModal.context);
    }
    if (typeof this._hidden === 'function') {
      this._hidden = this._hidden.bind(this);
      this._loaded = this._loaded.bind(this);
      this._hide = this._hide.bind(this);
      this._closeModal = this._closeModal.bind(this);
      this._closeModalClickedOutsidePage = this._closeModalClickedOutsidePage.bind(this);
    }
  }

  BoclipsModal.animationEnd =
    'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

  BoclipsModal.selector = function () {
    return $('#boclips-modal-container');
  };

  BoclipsModal.hide = function () {
    return this.selector().modal('hide');
  };

  BoclipsModal.setContext = function (context) {
    this.context = context;
  };

  BoclipsModal.onScroll = function () {
    $('.popover.in').popover('hide');

    if ($('#player-wrapper').length > 0 && $('.rp-resource').length > 0) {
      const $player = $('#player-wrapper');

      const playerOffset = $('.rp-resource').offset().top - 65;

      const isPositionFixed = $player.is('.fixed');

      if ($(this).scrollTop() > playerOffset && !isPositionFixed) {
        $player.addClass('fixed');
      }

      if ($(this).scrollTop() < playerOffset && isPositionFixed) {
        $player.removeClass('fixed');
      }

      const playerHeight = $player.height();

      // const toCrossPosition = $('.rp-resource').offset().top;

      const playerOffsetHeight = $('.rp-resource').height() - 50;

      if ($(this).scrollTop() > playerOffset + playerOffsetHeight - playerHeight) {
        $player.addClass('bottom');
      } else {
        $player.removeClass('bottom');
      }
    }
  };

  BoclipsModal.bindScroll = function () {
    const playerWidth = $('#player-wrapper').width();
    $('#player-wrapper').css({ width: playerWidth });
    window.addEventListener('scroll', BoclipsModal.onScroll);
  };

  BoclipsModal.bindShowMore = function () {
    $(document).off('click', '.rp-full-description');
    $(document).on('click', '.rp-full-description', function () {
      if ($('.short-description').hasClass('hide')) {
        $('#read_more').html('Read More');
      } else {
        $('#read_more').html('Read Less');
      }
      $('.short-description').toggleClass('hide');
      $('.full-description').toggleClass('hide');
    });
  };

  BoclipsModal.unbindScroll = function () {
    window.removeEventListener('scroll', BoclipsModal.onScroll);
  };

  BoclipsModal.prototype.setContext = function (context) {
    this.context = context;
  };

  BoclipsModal.prototype.show = function () {
    if (this._isVisible()) {
      this._hide();
    }
    const modalPromise = $.Deferred();
    if (this._isVisible()) {
      this._animateHide(modalPromise);
    } else if (this._isCreated()) {
      this._removeContent(modalPromise);
    } else {
      this._create(modalPromise);
    }
    this.$container.modal('show').on('hidden.bs.modal', this._hidden);

    const ajaxPromise = $.ajax({
      url: this.url.replace(/(\?|$)/, '.json$1'),
      type: 'GET',
      dataType: 'json',
      cache: false,
      data: this.params
    });
    return $.when(ajaxPromise, modalPromise).then(this._loaded).fail(this._redirect);
  };

  BoclipsModal.prototype._hidden = function () {
    if (LP.config.new_curriculum_manager) {
      LP.module('MyCurriculumManagerBase').setModalVisible(false);
    }
    $('.popover.in').popover('hide');
    BoclipsModal.unbindScroll();
    if (this.video_handler) {
      this.video_handler.pause();
    }
    if (this.context) {
      this.context.executeAction(LpBoclips.LpBoclipsActions.hideResource);
    }
    return this._reset_player();
  };

  // Fix for - videos keep playing after closing the RRP
  BoclipsModal.prototype._reset_player = function () {
    const playerContainer = this.$container.find('#boclips-player');
    playerContainer.replaceWith(
      $('<div>').append('<div class="boclips-player-loading"></div>').html()
    );
  };

  BoclipsModal.prototype._bindPlayer = function () {
    const playerContainer = $('#boclips-modal-container').find('#boclips-player');
    if (LP.config.logged_in && playerContainer.length > 0) {
      this.video_handler.init(playerContainer);
    }
    BoclipsModal.bindScroll();
  };

  BoclipsModal.bindExpandCompressPage = function () {
    $('.rp-expand-info').on('click', function () {
      $('.boclips-resource-page').addClass('rp-info-expanded');
    });
    $('.rp-compress-info').on('click', function () {
      $('.boclips-resource-page').removeClass('rp-info-expanded');
    });
    $('.rp-hide-info').on('click', function () {
      $('.boclips-resource-page').addClass('rp-info-hidden');
      $('.boclips-resource-page').removeClass('rp-info-expanded');
    });
    $('.rp-show-info').on('click', function () {
      $('.boclips-resource-page').removeClass('rp-info-hidden');
      $('.boclips-resource-page').removeClass('rp-info-expanded');
    });
  };

  BoclipsModal.tooltipPlacement = function (tooltipNode, triggeringNode) {
    const { clientWidth } = document.getElementsByTagName('body')[0];
    if (LP.isMobile() && clientWidth <= 899 && $(triggeringNode).offset().left >= 100) {
      return 'bottom';
    }
    return 'right';
  };

  BoclipsModal.bindTooltips = function () {
    $('.preview-source').tooltip({
      placement: BoclipsModal.tooltipPlacement,
      fallbackPlacement: 'auto'
    });
  };

  BoclipsModal.bindCopyLinkButton = function () {
    $(document).off('click', '.copy-boclips-link');
    $(document).on('click', '.copy-boclips-link', function (e) {
      e.preventDefault();
      const url = $(e.currentTarget).data('url');
      if (url === null || typeof url === 'undefined' || String(url).trim() === '') {
        return false;
      }
      if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        const input = document.createElement('input');
        input.id = 'copy-boclips-link-input';
        input.setAttribute('value', url);
        // Fix for RRP modals. (Firefox)
        // "Copy" needs to have the input created inside the modal.
        if ($('#boclips-modal-container').is(':visible')) {
          $('#boclips-modal-container .boclips-resource-page').append(input);
        } else {
          document.body.appendChild(input);
        }
        input.select();

        try {
          document.execCommand('copy');
          $(e.currentTarget)
            .tooltip({ title: 'Copied!', placement: 'bottom', trigger: 'manual' })
            .tooltip('show');
          setTimeout(function () {
            $('.copy-boclips-link').tooltip('hide');
          }, 2000);
        } catch (ex) {
          console.warn('Copy to clipboard failed.', ex);
        } finally {
          $('#copy-boclips-link-input').remove();
        }
        return true;
      }
      return true;
    });
  };

  BoclipsModal.bindTranscriptDownload = function () {
    this.deleteFileDownloadCookie = this.deleteFileDownloadCookie.bind(this);
    const self = this;
    $(document).off('click touch touchstart', '#video_transcript');
    $(document).on('click touch touchstart', '#video_transcript', function (event) {
      const $el = $(this);
      if ($el.hasClass('disabled')) {
        return false;
      }
      $el.addClass('disabled');
      $.fileDownload($el.attr('href'), {
        successCallback(url) {
          $el.removeClass('disabled');
          self.deleteFileDownloadCookie();
        },
        failCallback(responseHtml, url, error) {
          NotificationHelper.error(
            'Boclips educational videos are currently unavailable. Please try again later.',
            { autohide: 3000 }
          );
          $el.removeClass('disabled');
          self.deleteFileDownloadCookie();
        },
        abortCallback(url) {
          $el.removeClass('disabled');
          self.deleteFileDownloadCookie();
        }
      });
      return false;
    });
  };

  BoclipsModal.deleteFileDownloadCookie = function () {
    document.cookie =
      'fileDownload=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT; max-age= -1;Secure;SameSite=None';
  };

  BoclipsModal.prototype._loaded = function (ajaxResponse, modalResponse) {
    const data = ajaxResponse[0];
    if (data.page != null) {
      this.$container.html(data.page).addClass(this._animationClassIn());
    } else {
      this._redirect();
    }

    const self = this;
    this.$container.one(BoclipsModal.animationEnd, function () {
      self.$container.removeClass(self._animationClassIn());
      BoclipsModal.bindShowMore();
      self._bindPlayer();
      BoclipsModal.bindCopyLinkButton();
      BoclipsModal.bindTranscriptDownload();
      return true;
    });
    this.$container.find('#bo_player_modal').prepend(this._hiddenRow());
    this.$container
      .find('.js-resource-row > .close-button-wrap')
      .append(this._closeButton());

    if (this.$container.find('.row.shared_collection')[0]) {
      LP.module('SharedCollections').show();
    } else {
      LP.module('Resources').show();
    }
    BoclipsModal.bindTooltips();
    BoclipsModal.bindExpandCompressPage();
    $('.modal-backdrop, #boclips-modal-container .js-resource-row').on(
      'click',
      this._closeModal
    );
    $('#boclips-modal-container').on('mouseup', this._closeModalClickedOutsidePage);
  };

  BoclipsModal.prototype._closeModalClickedOutsidePage = function (e) {
    const page = $('#boclips-modal-container .boclips-resource-page');
    // if the target of the click isn't the container nor a descendant of the container
    if (!page.is(e.target) && page.has(e.target).length === 0) {
      return $('.boclips-modal-close').click();
    }
  };

  BoclipsModal.prototype._closeModal = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }
    return $('.boclips-modal-close').click();
  };

  BoclipsModal.prototype._hide = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }
    return this.$container.modal('hide');
  };
  BoclipsModal.prototype._modalContainer = function () {
    return `<div class="boclips-resource-page-modal modal container fade animated js-no-stackable-modal" id="boclips-modal-container">${this._spinner()}</div>`;
  };

  BoclipsModal.prototype._spinner = function () {
    return `<div class="spin-wrapper"> \
<i class="fa-solid fa-arrows-rotate fa-spin fa-4x"></i> \
</div>`;
  };

  BoclipsModal.prototype._closeButton = function () {
    return `<button class="btn btn-lg btn-default boclips-modal-close" type="button" data-dismiss="modal"> \
<span class="close-x">&times;</span> \
</button>`;
  };

  BoclipsModal.prototype._hiddenRow = function () {
    return `<div class='js-resource-row'><div class='close-button-wrap'></div></div>`;
  };

  BoclipsModal.prototype._isCreated = function () {
    return this.$container.length;
  };

  BoclipsModal.prototype._isVisible = function () {
    return this.$container.is(':visible');
  };

  BoclipsModal.prototype._create = function (promise) {
    this.$container = $(this._modalContainer()).appendTo('body');
    return promise.resolve();
  };

  BoclipsModal.prototype._removeContent = function (promise) {
    this.$container.html(this._spinner());
    return promise.resolve();
  };

  BoclipsModal.prototype._animateHide = function (promise) {
    $('.popover.in').popover('hide');
    const self = this;
    return this.$container
      .addClass(this._animationClassOut())
      .one(BoclipsModal.animationEnd, function () {
        self.$container.removeClass(self._animationClassOut());
        self.$container.scrollTop(0);
        self.$container.html(self._spinner());
        return promise.resolve();
      });
  };

  BoclipsModal.prototype._animationClassIn = function () {
    switch (this.transition) {
      case 'left':
        return 'bounceInLeft';
      case 'right':
        return 'bounceInRight';
      default:
        return 'bounceInUp';
    }
  };

  BoclipsModal.prototype._animationClassOut = function () {
    switch (this.transition) {
      case 'left':
        return 'bounceOutRight';
      case 'right':
        return 'bounceOutLeft';
      default:
        return 'bounceOutUp';
    }
  };

  BoclipsModal.prototype._redirect = function () {
    return (document.location.href = this.url.replace('.json', ''));
  };

  return BoclipsModal;
};

BoclipsModal = BoclipsModal();

LP.module('LpBoclips').BoclipsModal = BoclipsModal;
